module.exports = __webpack_public_path__ + "media/img/frontend_application/bg-upgrade-text-364ddb719199e8afd07668d51c5ef9a9.png";